/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { FlexContainer, Spacer, Text, theme } from "@nordcloud/gnui";
import { FilterHeader, Mode } from "~/components";
import { getSelectedMode } from "~/components/SidebarWithMultiSelect";
import { noop } from "~/tools";
import { getNumberFilterValue } from "../helpers";
import { NumberRangeInput } from "../NumberRangeInput";
import { FiltersProp } from "../types";

type Props = {
  filters: FiltersProp;
  updateFilters: (input: FiltersProp) => void;
  size?: "m" | "s";
  isExcludeSelected?: boolean;
  onModeChange?: (mode: Mode) => void;
};

export function LifeSpanInput({
  filters,
  updateFilters,
  size,
  isExcludeSelected,
  onModeChange,
}: Props) {
  return (
    <>
      <FilterHeader
        allowModeChange
        defaultMode={getSelectedMode(isExcludeSelected)}
        onSetSearch={noop}
        onModeChange={onModeChange}
      />
      <Spacer height={theme.spacing.spacing04} />
      <FlexContainer marginTop={theme.spacing.spacing04}>
        <Text>Specify the life span of the resource activity</Text>
      </FlexContainer>
      <div style={{ whiteSpace: "nowrap" }}>
        <div style={{ display: "inline-block" }}>
          <NumberRangeInput
            from={filters.lifeSpanFrom}
            to={filters.lifeSpanTo}
            size={size}
            onChangeFrom={(value: string) =>
              updateFilters({ lifeSpanFrom: getNumberFilterValue(value) })
            }
            onChangeTo={(value: string) =>
              updateFilters({ lifeSpanTo: getNumberFilterValue(value) })
            }
          />
        </div>
        <span>days</span>
      </div>
    </>
  );
}
